import { Component } from 'react'
import PropTypes from 'prop-types'

import toast from 'lib/toast'
import SignUpForm from 'components/authentication/registration/free-edition/SignUpForm'
import api from 'api'
import { messageFromResponseError } from 'utils/strings'

const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  requestedDemo: false,
  sourceUrl: 'https://app.gremlin.com', // For metric purposes
  isRegistering: false
}

export default class SignUp extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired
  }

  state = initialState

  handlePropChange = (prop, val) => this.setState({ [prop]: val })

  generateHandlePropChange = prop => value => this.handlePropChange(prop, value)

  handleSignUp = async () => {
    this.setState({ isRegistering: true })

    const { email, firstName, lastName, requestedDemo, sourceUrl } = this.state

    try {
      await api.users.freeEdition.sendPasswordInvite({
        email,
        firstName,
        lastName,
        requestedDemo,
        sourceUrl
      })
      toast({
        type: 'info',
        time: 0,
        text: `Activation link sent to ${email}`
      })

      await new Promise(resolve => this.setState(initialState, resolve))
    } catch (err) {
      toast({
        type: 'error',
        time: 6000,
        text: messageFromResponseError(
          err,
          'Unable to sign up. Please try again later.'
        )
      })
    } finally {
      if (this.state.isRegistering) this.setState({ isRegistering: false })
    }
  }

  setEmailInputRef = ref => {
    this.emailInputRef = ref
  }

  handleGoogle = async event => {
    event.preventDefault()
    const { requestedDemo, sourceUrl } = this.state

    window.location.href = api.authentication.generateFreeEditionGoogleUrl({
      requested_demo: requestedDemo,
      source_url: sourceUrl
    })
  }

  render() {
    const {
      email,
      firstName,
      lastName,
      requestedDemo,
      isRegistering
    } = this.state

    return (
      <SignUpForm
        disabled={isRegistering}
        email={email}
        firstName={firstName}
        handleEmailChange={this.generateHandlePropChange('email')}
        handleFirstNameChange={this.generateHandlePropChange('firstName')}
        handleGoogle={this.handleGoogle}
        handleLastNameChange={this.generateHandlePropChange('lastName')}
        handlerequestedDemoChange={this.generateHandlePropChange(
          'requestedDemo'
        )}
        handleSignUp={this.handleSignUp}
        lastName={lastName}
        requestedDemo={requestedDemo}
      />
    )
  }
}
